var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoubleChevronLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -0.5 17 17",
    id: "meteor-icon-kit__solid-double-chevron-left-s",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0607 3.06066L4.12132 8L9.0607 12.9393C9.6464 13.5251 9.6464 14.4749 9.0607 15.0607C8.4749 15.6464 7.5251 15.6464 6.93934 15.0607L0.93934 9.0607C0.35355 8.4749 0.35355 7.5251 0.93934 6.9393L6.93934 0.93934C7.5251 0.35355 8.4749 0.35355 9.0607 0.93934C9.6464 1.52513 9.6464 2.47487 9.0607 3.06066zM11.1213 8L16.0607 12.9393C16.6464 13.5251 16.6464 14.4749 16.0607 15.0607C15.4749 15.6464 14.5251 15.6464 13.9393 15.0607L7.9393 9.0607C7.3536 8.4749 7.3536 7.5251 7.9393 6.9393L13.9393 0.93934C14.5251 0.35355 15.4749 0.35355 16.0607 0.93934C16.6464 1.52513 16.6464 2.47487 16.0607 3.06066L11.1213 8z",
    fill: "#ffffff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleChevronLeft);
export default __webpack_public_path__ + "static/media/double-chevron-left.0f22b19558f8c3fa40c862b002ebc109.svg";
export { ForwardRef as ReactComponent };